import { useI18n } from '#imports'
import type { IMultiselectOption } from '~/types'

export const useCreditFilters = () => {
  const { t } = useI18n()

  const periodOptions: IMultiselectOption[] = [
    { id: 17, label: t('common.period_placeholder'), value: '0' },
    { id: 1, label: t('common.periods.month_1'), value: '1' },
    { id: 2, label: t('widget.credits.list_meili_search.periods.months_3'), value: '3' },
    { id: 3, label: t('widget.credits.list_meili_search.periods.months_6'), value: '6' },
    { id: 4, label: t('widget.credits.list_meili_search.periods.months_9'), value: '9' },
    { id: 5, label: t('common.periods.year_1'), value: '12' },
    { id: 6, label: t('common.periods.years_2'), value: '24' },
    { id: 7, label: t('common.periods.years_3'), value: '36' },
    { id: 8, label: t('common.periods.years_4'), value: '48' },
    { id: 9, label: t('common.periods.years_5'), value: '60' },
    { id: 10, label: t('widget.credits.list_meili_search.periods.years_6'), value: '72' },
    { id: 11, label: t('widget.credits.list_meili_search.periods.years_7'), value: '84' },
    { id: 12, label: t('widget.credits.list_meili_search.periods.years_8'), value: '96' },
    { id: 13, label: t('widget.credits.list_meili_search.periods.years_9'), value: '108' },
    { id: 14, label: t('widget.credits.list_meili_search.periods.years_10'), value: '120' },
    { id: 15, label: t('widget.credits.list_meili_search.periods.years_15'), value: '180' },
    { id: 16, label: t('widget.credits.list_meili_search.periods.years_20'), value: '240' }
  ]

  const organizationType: IMultiselectOption[] = [
    { id: 1, label: t('common.organization_label'), value: '0' },
    { id: 2, label: t('common.banks'), value: 'bank' },
    { id: 3, label: t('common.microcredits'), value: 'microcredit_company' }
  ]

  const incomeConfirmationTypes: IMultiselectOption[] = [
    { id: 1, label: t('common.no'), value: '0' },
    { id: 2, label: t('common.yes'), value: '1' },
    { id: 3, label: t('common.any'), value: 'any' }
  ]

  const guaranteeRequiredTypes: IMultiselectOption[] = [
    { id: 1, label: t('common.no'), value: '0' },
    { id: 2, label: t('common.yes'), value: '1' },
    { id: 3, label: t('common.any'), value: 'any' }
  ]

  return { periodOptions, organizationType, incomeConfirmationTypes, guaranteeRequiredTypes }
}

export default useCreditFilters
